import { render, staticRenderFns } from "./StatementDetails.vue?vue&type=template&id=72608139&"
import script from "./StatementDetails.vue?vue&type=script&lang=js&"
export * from "./StatementDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatementDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports